import { render, staticRenderFns } from "./storeMsgManage.vue?vue&type=template&id=1b83eb3a&scoped=true"
import script from "./storeMsgManage.vue?vue&type=script&lang=js"
export * from "./storeMsgManage.vue?vue&type=script&lang=js"
import style0 from "./storeMsgManage.vue?vue&type=style&index=0&id=1b83eb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83eb3a",
  null
  
)

export default component.exports